// extracted by mini-css-extract-plugin
module.exports = {"details__banner":"DetailsBanner_details__banner__2OEMR","banner__image":"DetailsBanner_banner__image__3lA1t","banner__overlay":"DetailsBanner_banner__overlay__2SZHU"};